module.exports = __webpack_public_path__ + "static/img/strukton-logo-diapositief.578e325.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/strukton-logo-diapositief.png
// module id = 5le9
// module chunks = 1